module.exports = __webpack_public_path__ + "static/media/cart-unselected.1ecc600b.png";